import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, Loading, Stack, styled, Text } from 'shell/components';

const MobileLoading = ({ onClickBack }) => {
    const { t } = useTranslation('assignment');

    return (
        <CustomContainer device={'mobile'}>
            <RootStack>
                <Button
                    sx={{ alignSelf: 'flex-start' }}
                    startIcon={<Icon kind={'arrowLeft'} />}
                    variant={'borderless'}
                    onClick={onClickBack}
                >
                    {t('common:controls.back', 'Back')}
                </Button>
                <CenterStack spacing={20}>
                    <Stack spacing={2}>
                        <Text align={'center'} component={'h1'} variant={'h6'} weight={'semibold'}>
                            {t('rubric.create-ai-rubric.loading.title', 'Your rubric is being generated!')}
                        </Text>
                        <Text align={'center'}>
                            {t(
                                'keep-window-open',
                                'Please keep this window open until this process completes. This may take a few minutes.'
                            )}
                        </Text>
                    </Stack>
                    <Loading />
                </CenterStack>
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        background: theme.palette.ensightful.shades[0],
    };
});

const RootStack = styled(Stack)(() => {
    return {
        position: 'relative',
        width: '100%',
        height: '80vh',
    };
});

const CenterStack = styled(Stack)(() => {
    return {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
    };
});

export default MobileLoading;
